import * as React from 'react';
import * as styles from './TableSeparator.css';

export const TableSeparator = () => {
  return (
    <tr>
      <td colSpan={10} className={styles['line']}></td>
    </tr>
  );
};
